import api from './client';

export const settingsApi = {
  getCompany:     ()           => api.get('/settings/company'),
  updateCompany:  (data: any)  => api.put('/settings/company', data),
  getBranches:    ()           => api.get('/settings/branches'),
  createBranch:   (data: any)  => api.post('/settings/branches', data),
  getLocations:   ()           => api.get('/settings/locations'),
  createLocation: (data: any)  => api.post('/settings/locations', data),
  getUsers:       ()           => api.get('/settings/users'),
  createUser:     (data: any)  => api.post('/settings/users', data),
  getRoles:       ()           => api.get('/settings/roles'),
};
